export default {
  courses: []
};
